import routerConfig from 'src/router-config';

function modelNotExisted(app, model) {
  return !app._models.some(({ namespace }) => {
    return namespace === model.namespace;
  });
}

export function getRouterData(app) {
  const routerData = {};

  Object.keys(routerConfig).forEach(path => {
    const config = routerConfig[path];
    !!config.models &&
      config.models.forEach(model => {
        if (modelNotExisted(app, model)) app.model(model);
      });

    routerData[path] = {
      ...config,
      name: config.name || '',
    };
  });
  return routerData;
}
